exports = module.exports = require("../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._3z-TTe8pKamRDDtKh3Zyjh{display:flex;flex-direction:column;margin:0;border-radius:3px;background:#fff;background-clip:content-box}._2_apLHH_P14xErEPEMPrSy{height:25px;text-align:left;line-height:20px;position:relative;padding:2px 10px;background:#fafafa;border-bottom:1px solid #d9d9d9;font-weight:700}._2-l4dK73YpzeAklE1iCkGh{position:absolute;top:3px;right:3px;width:10px;height:10px;background-image:url(\"http://img1.imgtn.bdimg.com/it/u=4152100876,641559203&fm=214&gp=0.jpg\");background-size:100% 100%;background-repeat:no-repeat}._1NmfGro4B0qi4Q_lTNecYo{flex:1;display:flex;flex-direction:column;height:inherit}", ""]);

// exports
exports.locals = {
	"panel": "_3z-TTe8pKamRDDtKh3Zyjh",
	"title": "_2_apLHH_P14xErEPEMPrSy",
	"delPanel": "_2-l4dK73YpzeAklE1iCkGh",
	"body": "_1NmfGro4B0qi4Q_lTNecYo"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules!./~/rt-sd-comp/sgiComp/SgiPanel.css
// module id = 1609
// module chunks = 1